import { RootState } from "./types";

export default {
    reload(state: RootState) {
        return state.reload;
    },
    getAzureAdStatus(state: RootState) {
        return state.azureAdStatus;
    },
    getAllowStockImages(state: RootState) {
        return state.allowStockImages;
    }
};
